/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { type TaskGenerator } from 'ember-concurrency';
import { task } from 'ember-concurrency-decorators';
import { perform } from 'ember-concurrency-ts';
import {
  INCLUDED_TIERS_FROM_PRICING_ENDPOINT,
  PRICING_5_1_PRICING_MODEL,
  PRICING_5_EARLY_STAGE_BUNDLE,
} from 'embercom/lib/billing';
import { hash } from 'rsvp';

export default class BillingUpdateSubsription extends Route {
  @service intercomEventService: $TSFixMe;
  @service router: $TSFixMe;
  @service customerService: $TSFixMe;
  @service appService: $TSFixMe;

  get app() {
    return this.appService.app;
  }

  get customer() {
    return this.customerService.customer;
  }

  get earlyStageGraduation() {
    return this.customerService.earlyStageGraduation;
  }

  beforeModel() {
    // Only accessible for Early Stage customers graduating to Pricing 5
    if (
      this.customerService.customer.cancellationRequestedOutsideMigration ||
      !this.earlyStageGraduation?.pricing5_X_Graduation
    ) {
      return this.router.transitionTo('apps.app.billing.index');
    }

    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: 'billing_update_subscription_page',
    });
  }

  async model() {
    return hash({
      customer: this.customer,
      earlyStageGraduation: this.earlyStageGraduation,
    });
  }

  afterModel() {
    return perform(this.requestGraduationPrices);
  }

  @task
  *requestGraduationPrices(): TaskGenerator<void> {
    let planIds = PRICING_5_EARLY_STAGE_BUNDLE.map(Number);
    let earlyStageModel = this.earlyStageGraduation.pricingModelForEarlyStagePlan;
    let pricesToLoad = [];

    if (this.customerService.isPriceLoaded(planIds, earlyStageModel) === false) {
      pricesToLoad.push({
        planIds,
        pricingModel: earlyStageModel,
        includeTiers: INCLUDED_TIERS_FROM_PRICING_ENDPOINT,
        source: 'update-subscription-page',
      });
    }

    if (this.customerService.isPriceLoaded(planIds, PRICING_5_1_PRICING_MODEL) === false) {
      pricesToLoad.push({
        planIds,
        pricingModel: PRICING_5_1_PRICING_MODEL,
        includeTiers: INCLUDED_TIERS_FROM_PRICING_ENDPOINT,
        source: 'update-subscription-page',
      });
    }

    if (pricesToLoad.length > 0) {
      yield this.customerService.bulkLoadPrices(pricesToLoad);
    }
  }
}
